import { Component, Input, inject } from '@angular/core';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { AdminAccess, CompanyAccess } from 'src/model/companyAccess.model';
import { AdminAccessService } from 'src/services/admin-access.service';
import { AccessAction, AccessActionComponent } from '../access-action/access-action.component';
import { AdminCompanyListComponent } from '../admin-company-list/admin-company-list.component';

@Component({
    selector: 'app-admin-access-item',
    templateUrl: './admin-access-item.component.html',
    styleUrl: './admin-access-item.component.scss',
    standalone: false
})
export class AdminAccessItemComponent {
  private sharedService = inject(SharedService);
  private adminAccessService = inject(AdminAccessService);

  @Input() adminAccessItem: AdminAccess;
  @Input() companyAccessList: CompanyAccess[] = [];
  @Input() isOnDuty = false;

  readonly maxRetryAttempts = 3;

  openCloneAdminModal() {
    const modalRef = this.sharedService.openModal(AccessActionComponent);
    modalRef.componentInstance.action = AccessAction.Clone;
    modalRef.componentInstance.companyAccessList = this.companyAccessList;
    modalRef.componentInstance.currentAdmin = this.adminAccessItem.username;
    modalRef.componentInstance.currentAccess = this.adminAccessItem;
  }

  openRevokeAdminModal() {
    const currentAdmin = this.adminAccessItem.username;
    if (this.isOnDuty == false) {
      const modalRef = this.sharedService.openModal(AccessActionComponent);
      modalRef.componentInstance.companyAccessList = this.companyAccessList;
      modalRef.componentInstance.action = AccessAction.RevokeTransfer;
      modalRef.componentInstance.currentAdmin = currentAdmin;
    } else {
      const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
      modalRef.componentInstance.message = "Are you sure you want to revoke on duty access for this admin?";

      modalRef.result.then(async (confirm) => {
        if (confirm) {
          const revoked = await this.adminAccessService.revokeAccessWithRetry(this.adminAccessItem.username, this.adminAccessItem.onDutyAccess);
          if (revoked.companyIds.length === this.adminAccessItem.onDutyAccess.length) {
            this.sharedService.openAlert(`Revoked all ${revoked.companyIds.length} on duty access of ${this.adminAccessItem.username}!`, ALERT_TYPE.SUCCESS, true);
          } else {
            this.sharedService.openAlert(`Revoked ${revoked.companyIds.length} of ${this.adminAccessItem.onDutyAccess.length} on duty access of ${this.adminAccessItem.username}!`, ALERT_TYPE.DANGER, true, {auto: false});
          }
        }
      });
    }
  }

  openAdminCompanyListModal() {
    const modalRef = this.sharedService.openModal(AdminCompanyListComponent);
    modalRef.componentInstance.companyAccessList = this.companyAccessList.filter(access => access.Username == this.adminAccessItem.username);
    modalRef.componentInstance.currentAdmin = this.adminAccessItem.username;
  }
}
